"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_rxk_1 = require("react-rxk");
const spinner_1 = require("./spinner");
/**
 * Convert a react component to a one that accepts rxjs observable on all its props
 */
function componentToRxSpinner(component) {
    return react_rxk_1.componentToRx(component, React.createElement(spinner_1.Spinner, null));
}
exports.componentToRxSpinner = componentToRxSpinner;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/rx.js
// module id = 511
// module chunks = 0